<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                        @click="showSearchDialog">查询（F2）</el-button>
                </div>
                <div class="search-ctn-right">
                    <div class="section-summary">
                        <div>
                            <span>合计：{{ summaryStr }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table highlight-current-row class="account-table" style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }" border="" :data="tableData" height="700px"
                    ref="multipleTable" @sort-change="sortChange" v-el-table-infinite-scroll="tableLoad"
                    empty-text="暂无明细账数据" :summary-method="getSummaries" show-summary>
                    <el-table-column show-overflow-tooltip width="100" prop="CreateTime" label="开单日期"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" prop="OrderName" label="业务类型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="单据号"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180" prop="EntpCusName" label="客户/供应商"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="RSumPayable" label="应收账款"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="PSumPayable" label="应付账款"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="AlreadyPaid" label="已结金额">
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSettle" class="c-active">{{ scope.row.AlreadyPaid }}</i>
                            <i v-else>0</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="PayTypeName" label="支付方式"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180" prop="SettleCode" label="结算单号"></el-table-column>
                    <el-table-column show-overflow-tooltip width="70" prop="StateName" label="状态">
                        <template slot-scope="scope">
                            <i v-if="scope.row.StateName == '已结帐'" class="c-active">{{ scope.row.StateName }}</i>
                            <i v-else>{{ scope.row.StateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" prop="PayTime" label="收（付）款时间">
                        <template slot-scope="scope">
                            <i v-if="scope.row.StateName == '已结帐'" class="c-active">{{ scope.row.PayTime }}</i>
                            <i v-else>-</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="170px" prop="SettleTime" label="结帐时间">
                        <template slot-scope="scope">
                            <i v-if="scope.row.StateName == '已结帐'" class="c-active">{{ scope.row.SettleTime }}</i>
                            <i v-else>-</i>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        show-overflow-tooltip
                        sortable
                        width="107px"
                        prop="ApplyTime"
                        label="申请时间"
                    ></el-table-column>
                    <el-table-column show-overflow-tooltip width="70px" prop="Operator" label="申请人"></el-table-column> -->
                    <el-table-column show-overflow-tooltip min-width="100" prop="Remark" label="备注"></el-table-column>
                </el-table>
            </div>
            <el-dialog :close-on-click-modal="false" title="明细账搜索" :visible.sync="dialogVisible" width="400px"
                append-to-body v-dialog-drag lock-scroll :modal="false" id="search-dc-dialog"
                custom-class="search-item-dialog" style="margin-left: -170px">
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="88px">
                        <el-form-item label="客户/供应商">
                            <el-select class="search-item" size="small" style="width: 100%" v-model="searchData.Keyword"
                                remote filterable allow-create placeholder="请输入客户/供应商名称" :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad" popper-class="my-select">
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName"
                                    :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务类型">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.OrderType">
                                <el-option v-for="item in orderTypeList" :key="item.Value" :label="item.Text"
                                    :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单号">
                            <el-input class="search-item" style="width: 100%" size="small"
                                v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode"
                                placeholder="请输入订单号"></el-input>
                        </el-form-item>
                        <el-form-item label="结算单号">
                            <el-input class="search-item" style="width: 100%" size="small"
                                v-model.trim="searchData.SettleCode" v-filter-special-char="searchData.SettleCode"
                                placeholder="请输入结算号"></el-input>
                        </el-form-item>
                        <el-form-item label="结款状态">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text"
                                    :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申请人">
                            <el-select v-model="searchData.ApplyId" style="width: 100%" class="search-item" size="small"
                                filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName"
                                    :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="结帐日期">
                            <el-date-picker size="small" style="width: 100%" v-model="datetime1" type="daterange"
                                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            summaryStr: '',
            datetime1: [],
            loading: '',
            dialogVisible: false,
            stopFresh: false,
            isShowSummary: false,
            searchData: {
                State: '',
                Keyword: '',
                OrderCode: '',
                OrderType: '',
                SettleCode: '',
                ApplyId: '',
                StartDate: '',
                EndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 25
            },
            searchParams: {},
            tableData: [],
            tableDataLength: 0,
            stateList: [
                { Text: '全部', Value: '-1' },
                { Text: '未结帐', Value: '0' },
                { Text: '已结帐', Value: '1' }
            ],
            orderTypeList: [
                { Text: '全部', Value: '-1' },
                { Text: '销售', Value: '0' },
                { Text: '销售退货', Value: '1' },
                { Text: '采购', Value: '2' },
                { Text: '采购退货', Value: '3' }
            ],
            SIdList: [],
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.showSearchDialog();
            }
            if (key === 13) {
                if (that.dialogVisible) that.handleSearch();
            }
            if (key === 27) {
                if (that.dialogVisible) that.closeSearchDialog();
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.initSearchSelectData();
            this.dialogVisible = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerAndSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getSIdList();
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        resetSearch() {
            this.searchData = {
                State: '',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                ApplyId: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 25
            };
            this.datetime1 = [];
            // this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (that.searchData.page == 1) {
                that.searchParams = { ...that.searchData };
            } else {
                that.searchParams.page = that.searchData.page;
            }
            that.stopFresh = true;

            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_N/GetItemizedAccounts',
                    data: that.searchParams
                })
                .then(res => {
                    let data = res.data;
                    that.tableDataLength = res.count;
                    if (!data) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    }

                    that.summaryStr = data.SummaryStr;

                    let list = [...that.tableData, ...data.DataList];
                    that.tableData = list;

                    that.stopFresh = data.DataList.length < that.searchData.limit;
                });
        },
        handleSearch() {
            this.tableData = [];
            this.searchData.page = 1;
            this.getTableData();
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.ApplyId;
        },
        getSummaries(param) {
            const { data } = param;
            let applyRAmountTotal = 0;
            let applyPAmountTotal = 0;
            let alreadyPaidTotal = 0;
            data.forEach(ele => {
                applyRAmountTotal = (Number(applyRAmountTotal) + Number(ele.RSumPayable)).toFixed(2);
                applyPAmountTotal = (Number(applyPAmountTotal) - Number(ele.PSumPayable)).toFixed(2);
                alreadyPaidTotal = (Number(alreadyPaidTotal) + Number(ele.AlreadyPaid)).toFixed(2);
            });
            return ['', '', '合计：' + this.tableDataLength, '', applyRAmountTotal, applyPAmountTotal, alreadyPaidTotal, '', ''];
        }
    }
};
</script>
<style lang="less" scoped>
.c-active {
    color: #0dbdae;
}

.data-count {
    padding: 5px;
    display: flex;

    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;

        >p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}

#search-dc-dialog,
#confirm-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#confirm-dialog::-webkit-scrollbar {
    display: none;
}

.v-content {
    width: 100%;
    height: calc(100vh);
}

.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.table-ctn {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
}
</style>
<style lang="less">
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }

    .account-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 4px 0;
                }
            }
        }

        .el-table__footer {
            td {
                padding: 4px 0;
            }
        }
    }
}

.el-table__row {
    td:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}

.el-table__header {
    th:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}

.el-table {
    overflow: visible !important;
}
</style>
